function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "add_app"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m9 2h-5c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h5c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2zm-.003 7h-4.997v-5h5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20 2h-5c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h5c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2zm-.003 7h-4.997v-5h5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m9 13h-5c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h5c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2zm-.003 7h-4.997v-5h5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.5 16.5h-2v-2c0-.553-.448-1-1-1s-1 .447-1 1v2h-2c-.552 0-1 .447-1 1s.448 1 1 1h2v2c0 .553.448 1 1 1s1-.447 1-1v-2h2c.552 0 1-.447 1-1s-.448-1-1-1z"
})));

var Svg007App = function Svg007App(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg007App, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/007-app.1238a315.svg";
export { ForwardRef as ReactComponent };